var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-wrap"},[_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require('../assets/images/banner.png').default,"alt":""}})]),_vm._v(" "),_c('aboutUs'),_vm._v(" "),_c('management'),_vm._v(" "),_c('atlas'),_vm._v(" "),_c('industry')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }